// components/GlobalTracking.tsx
'use client';

/* eslint-disable @next/next/no-img-element */
import type { CSSProperties } from 'react';
import Script from 'next/script';
import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google';

export default function GlobalTracking() {
  return (
    <>
      {/* GA4 (use your GA4 "G-" id here) */}
      <GoogleTagManager gtmId="G-6FPEYB7W6P" />
        <GoogleTagManager gtmId="GTM-T8BK9F5Z" />
        <GoogleTagManager gtmId="GTM-55VVP7H4" />
        <GoogleTagManager gtmId="GTM-T8BK9F5" />
        <GoogleTagManager gtmId="AW-751049628" />
      {/* <GoogleTagManager gtmId="AW-751049628" /> */}

      {/* Facebook Pixel noscript */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' } as CSSProperties}
          src="https://www.facebook.com/tr?id=1090187464740445&ev=PageView&noscript=1"
          alt="Facebook Pixel"
        />
      </noscript>

      {/* Pearl Diver */}
      <Script
        src="https://tag.pearldiver.io/ldc.js?pid=6e92b3096324c9bbe09ada1a7e0f1ec8&aid=16de03f2"
        strategy="afterInteractive"
        async
      />

      {/* Chatbot loader */}
      <Script id="chatbot-loader" strategy="afterInteractive">
        {`
          window.agentId = '43a8ea00-5fd3-4284-ab51-6a7ce8c7d98c';
          window.baseurl = 'https://thevirtualgurus.ai/';
          window.CHATBOT_SVG = '<svg viewBox="-9 -9 41 41" style=\\"background-color: rgb(0, 38, 61); width: 55px; height: 55px; border-radius: 8px; box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 4px; fill: rgb(255, 255, 255);\\"><path d=\\"M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M9 11H7V9h2zm4 0h-2V9h2zm4 0h-2V9h2z\\"></path></svg>';

          const chatbotScript = document.createElement("script");
          chatbotScript.src = window.baseurl + "js/chatbot-embed.js";
          chatbotScript.async = true;
          document.head.appendChild(chatbotScript);
        `}
      </Script>

      {/* Microsoft UET — use afterInteractive in App Router */}
      <Script id="ms-uet" strategy="afterInteractive">
        {`
          (function(w,d,t,r,u){
            var f,n,i;
            w[u]=w[u]||[],f=function(){
              var o={ti:"17533059", enableAutoSpaTracking: true};
              o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")
            },
            n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){
              var s=this.readyState;
              s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)
            },
            i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)
          })(window,document,"script","https://bat.bing.com/bat.js","uetq");
        `}
      </Script>

      {/* Bing noscript */}
      <noscript>
        <img
          src="https://bat.bing.com/action/0?ti=17533059&Ver=2"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' } as CSSProperties}
          alt=""
        />
      </noscript>
    </>
  );
}
